import {IAwsFormData, IImomoResponse, IAccessToken} from './api.types';

export interface IAccessTokenApi {
  getAwsFormData():ng.IPromise<IAwsFormData>;
  getUserToken(username:string, password:string):ng.IPromise<IAccessToken>;
}

export default class AccessTokenApi implements IAccessTokenApi {
  static $inject = ['$http', 'backendUrl'];

  private endpoint:string;

  constructor(private $http:ng.IHttpService, backendUrl:string) {
    this.endpoint = `${backendUrl}/access_tokens`;
  }

  getAwsFormData():ng.IPromise<IAwsFormData> {
    return this.$http<IImomoResponse<IAwsFormData>>({
      url: `${this.endpoint}/awsform`,
      method: 'GET'
    }).then((httpData) => {
      return httpData.data.resources[0];
    });
  }

  getUserToken(username:string, password:string):ng.IPromise<IAccessToken> {
    return this.$http<IImomoResponse<IAccessToken>>({
      url: this.endpoint,
      method: 'POST',
      data: {
        usernameOrEmail: username,
        password: password
      }
    }).then(httpData => httpData.data.resources[0]);
  }

}



/** WEBPACK FOOTER **
 ** ./app/api/access-token-api.service.ts
 **/